import { createContext, useContext } from "react";

export const NewFeaturesContext = createContext(null);

export const useNewFeaturesContext = () => useContext(NewFeaturesContext);
